<div nz-row [nzGutter]="[16, 6]">
	<div nz-col class="gutter-row print-fullscreen content" [nzSpan]="18">
		<div class="top-row-with-sidebar mb-2 flexrow print-hide">
			<app-splitbutton [elements]="[backToParticipantSplitButton]"></app-splitbutton>
			<app-select-exports-button
					[reportConfigsinMenu]="menuReportConfigs"
					(reportConfigToPrint)="setPrintReportId($event)"
					[listOfSelectedParticipants]="selectedParticipant"
					[exportConfigs]="exportConfigs"
					[itemId]="itemId"
					sourceWindow="workflowItemDetail"
			>
			</app-select-exports-button>
		</div>
		<div nz-row [nzGutter]="[16, 6]" *ngIf="workflowItem">
			<div nz-col [nzSpan]="24">
				<div nz-row [nzGutter]="[16, 6]">
					<!--TODO wiederholbare workflowschritte, wenn wiederholbar und ageschlossen nzSpan soll jeweils 12 betragen-->
					<div *ngIf="!workflowItemStatus?.completed" nz-col [nzSpan]="24" class="print-hide">
						<nz-card nzTitle="{{ workflowItem?.name }} ({{ workflowStartedString | translate }})">
							<div class="card-body">
								<div *ngTemplateOutlet="workflowStartContinueCard"></div>
							</div>
						</nz-card>
					</div>
					<div *ngIf="workflowItemStatus?.completed" nz-col [nzSpan]="24" class="print-hide">
						<nz-card nzTitle="{{ workflowItem?.name }} ({{ 'status.finished' | translate }})">
							<div class="card-body">
								<div *ngTemplateOutlet="workflowFinishedCard"></div>
							</div>
						</nz-card>
					</div>
					<div [hidden]="!workflowItemStatus?.completed" nz-col [nzSpan]="24">
						<workflow-report-card [participant]="participant" [usedReportConfigs]="printReportConfigs || reportConfigs" [reportData]="reportData">
						</workflow-report-card>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div nz-col [nzSpan]="6" class="print-hide">
		<workflow-projektsidebar [currentParticipant]="participant">
		</workflow-projektsidebar>
	</div>
</div>

<ng-template #workflowStartContinueCard>
	<div *ngIf="showStartContinueCard" nz-row [nzGutter]="[16,8]">
		<div nz-col>
			<div *ngTemplateOutlet="workflowViewModeSelection"></div>
		</div>
		<div nz-col nzSpan="11">
			<app-splitbutton [elements]="workflowStartedContinueSplitButton" size="large" [noIcon]="true" [block]="true"></app-splitbutton>
		</div>
		<nz-alert *ngIf="recommendedViewMode == 'wizard' && selectedViewMode == 'compact'"
					nzType="warning" nzShowIcon
					nzMessage="{{ 'message.warning.viewMode.notRecommended.title' | translate }}"
					nz-tooltip="{{ 'message.warning.viewMode.notRecommended.description' | translate }}"
					nz-col
		></nz-alert>
	</div>
	<div *ngIf="!showStartContinueCard" class="big-text">
		<nz-alert nzType="warning" nzShowIcon
				nzMessage="{{ 'message.warning.workflow.unstartedAndNoPermission'| translate }}"
				nz-col
		></nz-alert>
	</div>
</ng-template>

<ng-template #workflowFinishedCard>
	<div *ngIf="questionnaireWorkflowItem" nz-row [nzGutter]="[16,8]">
		<div nz-col>
			<div *ngTemplateOutlet="workflowViewModeSelection"></div>
		</div>
		<div nz-col nzSpan="11">
			<app-splitbutton [elements]="workflowFinishedSplitButton" size="large" [noIcon]="true" [block]="true"></app-splitbutton>
		</div>
		<nz-alert *ngIf="recommendedViewMode == 'wizard' && selectedViewMode == 'compact'"
					nzType="warning" nzShowIcon
					nzMessage="{{ 'message.warning.viewMode.notRecommended.title' | translate }}"
					nz-tooltip="{{ 'message.warning.viewMode.notRecommended.description' | translate }}"
					nz-col
		></nz-alert>
	</div>
</ng-template>

<ng-template #workflowViewModeSelection>
	<nz-radio-group [(ngModel)]="selectedViewMode" nzSize="large" (ngModelChange)="selectedViewMode$.next($event)" class="round-radio-button-wrapper">
		<label nz-radio-button nzValue="wizard">
			<i-feather class="icon" [name]="distractionFreeWizardIcon"></i-feather>
			{{ 'workflow.distractionfreeWizard' | translate }}
		</label>
		<label nz-radio-button nzValue="compact">
			<i-feather class="icon" [name]="compactViewIcon"></i-feather>
			{{ 'workflow.compactView' | translate }}
		</label>
	</nz-radio-group>
</ng-template>
